/**************************************************
 * Nombre:       Formulario_Looks
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FlagOutlined, HomeOutlined, Layers} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRENDA} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import Tarjeta_Producto from "../Tarjeta/Tarjeta_Producto";
import IngresoSelectMultipleObjetoId from "../../Modulo_formularios/Componentes/IngresoSelectMultipleObjetoId";


const Formulario_Looks = ({...props}) => {
    const [colecciones, setColecciones] = useState([])
    const [productos, setProductos] = useState([])


    useEffect(() => {

        obtenerCol('colecciones').then((dox) => {
            setColecciones(dox.data)
        })

        obtenerCol('productos').then((dox) => {
            setProductos(dox.data)
        })

    }, [])

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Estado y Coleccion</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'}
                                   dato={'estado'}  {...props}
                                   opciones={ESTADOSPRENDA.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectPropId Icono={Layers} nombre={'Coleccion'} propiedad={'nombre'} propiedadId={'id'}
                                         dato={'coleccion'} datoId={'idColeccion'}{...props}
                                         opciones={colecciones}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Foto de 1200px por 800px tamaño max 600Kb</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={8} ancho={6}
                                       dato={'img'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectFalsoVerdadero Icono={HomeOutlined} nombre={'Aparece en Home'}
                                                 dato={'home'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Prendas Relacionadas</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoSelectMultipleObjetoId {...props} dato={'productos'} Tarjeta={Tarjeta_Producto}
                                                   opciones={productos}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Looks